import "../styles/footer.css";
function Footer(props) {
  return (
    <footer
      className="-md -sm -xs u-clearfix u-footer u-pallete-2-base"
      id="sec-3e3a"
    >
      <div className="container-footer w-container">
        <div className="d-flex">
          <div className="footer-column w-clearfix w-col w-col-8">
            <img src="/images/logo.png" alt="" height="60" />
            <p className=" u-text mt-0px">
              <span className=" u-text u-text-palette-2-base u-text-3">
                {props.t("footer_1")}
              </span>
              <br />
            </p>
          </div>
          <div className="footer-column w-clearfix w-col w-col-8">
            <h3 className=" u-text u-text-palette-2-base u-text-2"></h3>
            <p className="footer-links">
              <a href="#Nosotros">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_2")}
                  <br />
                </span>
              </a>
              <a href="#Dirigido">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_3")}
                </span>
              </a>
              <span>
                <br />
              </span>
              <a href="#Nuestros">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_4")}
                  <br />
                </span>
              </a>
              <a href="#Funcionalidades">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_5")}
                  <br />
                </span>
              </a>
              <a href="#Mision">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_6")}
                  <br />
                </span>
              </a>
              <a href="#Experiencia">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_7")}
                  <br />
                </span>
              </a>
              <a href="">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {props.t("footer_8")}
                  <br />
                </span>
              </a>
            </p>
          </div>
          <div className="footer-column w-clearfix w-col w-col-8">
            <h3 className=" u-text u-text-palette-2-base u-text-2">
              {props.t("footer_9")}
            </h3>
            <p className="footer-links">
              <a href="">
                <span className=" u-text u-text-palette-2-base u-text-3">
                  (+1) 954 361 8716
                  <br />
                </span>
              </a>
              <a href="">
                <span className=" u-text u-text-palette-2-base u-text-3">
                  support@shelf-e.com
                  <br />
                </span>
              </a>
              <a href="">
                <span className=" u-text u-text-palette-2-base u-text-3">
                  8400 NW 36th St, Ste 450,
                </span>
              </a>
              <a href="">
                <span className=" u-text u-text-palette-2-base u-text-3">
                  Doral, FL, US, 33166-6606
                </span>
              </a>
            </p>
          </div>

          <div className="footer-column w-clearfix w-col w-col-8">
            <h3 className=" u-text u-text-palette-2-base u-text-2">
              {props.t("footer_10")}
            </h3>
            <p className="footer-links">
              <a href="https://www.linkedin.com/company/shelfe/?viewAsMember=true">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  <img
                    src="/images/linkedin.svg"
                    width="20"
                    height="20"
                    alt="Twitter icon"
                  />
                  <br />
                </span>
              </a>
              <a href="">
                <span className=" u-text u-text-palette-2-base u-text-2">
                  {" "}
                  <img
                    src="/images/whatsapp.svg"
                    width="20"
                    height="20"
                    alt="Instagram icon"
                  />
                  <br />
                </span>
              </a>
            </p>
          </div>
        </div>

        <br className="divider-footer" />
        <p className="u-align-center u-text u-text-palette-2-base u-text-4">
          © {new Date().getFullYear()} Shelf-e. {props.t("footer_11")}
        </p>
      </div>
    </footer>
  );
}

export default Footer;

